<script>
  export let item;
  export let key = undefined;
  export let session;
  export let indent=0;

  const TOTAL_MAX_WIDTH = 80; 
  let max_width = TOTAL_MAX_WIDTH - indent*2 - (key || '').length
  const EXPANDED_MAX_CHILDREN = [10, 5]
  let expanded; 

  let header;
  let summary;
  let children;
  let closing;
  let remote = false;
  let nonString = false;
  // console.log(item)
  $: {
    remote = false;
    nonString = false;
    if (item instanceof Uint8Array) {
      item = '0x'+Array.from(item).map(x => '0'+x.toString(16)).map(x => x.slice(x.length-2)).reduce((p, v, i) => p+(i%2 == 0 ? ' ': '')+v)
      nonString = true;
    }
    if (typeof item === 'string') {
      if (item.includes('\n')) {
        children = item.split('\n').map(x => ['', x]);
        expanded = children.length <= (EXPANDED_MAX_CHILDREN[indent] || 0)
        header = ''
        summary = item.slice(0, max_width-30) + ` ... (${children.length} lines)`
      } else if (item.length > max_width) {
        children = Array(Math.ceil(item.length/(max_width-2))).fill(null).map((_, i) => ['', item.slice(i*(max_width-2), (i+1)*(max_width-2))])
        expanded = children.length <= (EXPANDED_MAX_CHILDREN[indent] || 0)
        header = ''
        summary = children[0][1].slice(0, max_width-30) + ` ... (${children.length} wraps)`
      }
    } else if (item && item._isTelekinesisObject) {
      if (item._target.session[0] !== session) {remote = true}
      nonString = true;
      header = item._state.repr + ' {'
      header = header.length > max_width ? header.slice(0, max_width-3) + '...' : header
      summary = header + `attributes: ${Array.from(item._state.attributes.keys()).join(', ')}; methods:  ${Array.from(item._state.methods.keys()).join(', ')} }`
      summary = summary.length > max_width ? summary.slice(0, max_width-3) + '...' : summary
      children = [
        [
          'attributes', 
          item._state.attributes instanceof Map ? 
            Array.from(item._state.attributes.entries()).reduce((p, [k, v]) => {p[k] = v; return p}, {}) :
            Array.from(item._state.attributes.values()) 
        ], [
          'methods',
          Array.from(item._state.methods.entries()).reduce((p, [k, v]) => {p[k] = v; return p}, {})
        ]
      ]
      expanded = children.length <= (EXPANDED_MAX_CHILDREN[indent] || 0)
    } else if (['undefined', 'number', 'boolean'].includes(typeof item) || item === null) {
      nonString = true;
    } else {
      nonString = true;
      if (item instanceof Array) {
        header = '[';
        closing = ']'
      } else {
        header = '{';
        closing = '}'
      }
      summary = JSON.stringify(item)
      summary = summary.length > max_width ? summary.slice(0, max_width-5) + '... '+ closing : summary;
      children = Object.entries(item);
      expanded = children.length <= (EXPANDED_MAX_CHILDREN[indent] || 0)
    } 

  }

</script>

{#if summary}
  {#if expanded}
    <span on:click={() => {expanded = !expanded}} style="cursor: pointer;"><span style='color: var(--secondary);'> {'▼'} {key ? key +':': ''}</span> 
    {#if remote}
      <span style='color: var(--primary)'>{'≈'}</span>
    {/if}
    {#if header.includes('[92m≈[0m')}
      {header.split('[92m≈[0m')[0]}<span style='color: var(--primary)'>{'≈'}</span>{header.split('[92m≈[0m').slice(1).join('[92m≈[0m')}
    {:else}
      {header}
    {/if}
    
    <br></span>
    {#each children as [childName, child]}
      <span style='color: var(--tertiary); user-select: none;'>{'| '.repeat(indent+1)} </span> <svelte:self item={child} key={childName} indent={indent+1}/>
      <br>
    {/each}
    <span style='color: var(--tertiary); user-select: none'>{'| '.repeat(indent)} </span>{closing || ''}
  {:else}
    <span on:click={() => {expanded = !expanded}} style="cursor: pointer;"> <span style='color: var(--secondary);'> {'▶'} {key ? key +':': ''}</span>
    {#if remote}
      <span style='color: var(--primary)'>{'≈'}</span>
    {/if}
    {#if summary.includes('[92m≈[0m')}
      {summary.split('[92m≈[0m')[0]}<span style='color: var(--primary)'>{'≈'}</span>{summary.split('[92m≈[0m').slice(1).join('[92m≈[0m')}
    {:else}
      {summary}
    {/if}
     </span>
  {/if}
{:else}
  <span style='color: var(--secondary'> {key ? key +':': ''}</span> 
  {#if !nonString && item}
    <span style='color: #bbb'>
      <!-- {console.info(nonString, item) || ''} -->
      {#if item.includes('[92m≈[0m')}
        {item.split('[92m≈[0m')[0]}<span style='color: var(--primary)'>{'≈'}</span>{item.split('[92m≈[0m').slice(1).join('[92m≈[0m')}
      {:else}
        {item}
      {/if}
    </span>
  {:else}
    {item}
  {/if}
{/if}
